module.exports = __webpack_public_path__ + "static/ajluni-9df1954467628c093b9ff8f4c8336606.png";